import { create } from 'zustand';

export interface PodSecurityContextData {
  runAsNonRoot?: boolean;
  runAsUser?: number;
  runAsGroup?: number;
  seLinuxOptions?: {
    level?: string;
    role?: string;
    type?: string;
    user?: string;
  };
}

interface PodSecurityContextState {
  isPodSecurityContextSelected?: boolean;
  podSecurityContext?: PodSecurityContextData;
}

const initialState: PodSecurityContextState = {
  isPodSecurityContextSelected: false,
  podSecurityContext: undefined,
};

interface PodSecurityContextAction {
  togglePodSecurityContextSelected: (selected?: boolean) => void;
  updatePodSecurityContext: (data: PodSecurityContextData) => void;
  reset: () => void;
}

export const usePodSecurityContextStore = create<
  PodSecurityContextState & PodSecurityContextAction
>()((set) => ({
  ...initialState,
  togglePodSecurityContextSelected: (selected) => set({ isPodSecurityContextSelected: selected }),
  updatePodSecurityContext: (data) => set({ podSecurityContext: data }),
  reset: () => set(initialState),
}));
